import { ReactNode } from 'react';
import styles from './FAQ.module.css';

// The empty aria-labelledby / id attributes below are unwired a11y placeholders.
// Backlog: docs/a11y-maintenance-backlog.md#faq

export const FAQContainer = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return (
    <section
      className={className ? `${styles.container} ${className}` : styles.container}
      aria-labelledby=""
    >
      {children}
    </section>
  );
};

export const FAQElement = ({
  className,
  title,
  description,
}: {
  className?: string;
  title: string;
  description: React.ReactNode;
}) => {
  return (
    <article className={className ? `${styles.element} ${className}` : styles.element}>
      <h5 id="">{title}</h5>
      <div className="description" aria-labelledby="">
        {description}
      </div>
    </article>
  );
};
